import(/* webpackMode: "eager" */ "/Users/mike/Documents/irl-sidequests/apps/web/src/app/error.tsx");
